import React from "react";
import { Autocomplete, TextField, Chip } from "@mui/material";

const MultiSelectAutocomplete = ({
  id = "multi-select-autocomplete",
  placeholder = "Select items",
  options = [],
  value = [],
  labelKey = "username",
  disabled = false,
  onChange = () => {},
}) => {
  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      id={id}
      options={options.filter(
        (option) => !value.some((v) => v.id === option.id)
      )}
      getOptionLabel={(option) => option[labelKey] || ""}
      value={value}
      onChange={onChange}
      disabled={disabled}
      filterSelectedOptions
      fullWidth
      renderTags={(selected, getTagProps) =>
        selected.map((option, index) => (
          <Chip
            key={option.id || option[labelKey]}
            label={option[labelKey]}
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={(params) => (
        <TextField {...params} placeholder={placeholder} fullWidth />
      )}
    />
  );
};

export default MultiSelectAutocomplete;
